<template>
  <div class="checkout-summary-wrapper">
    <delivery-methods-edit-dp
      show-continue
      @close="save"
      :selected-method="
        $store.state.checkout.order_data.delivery.dp.deliveryMethod
      "
      v-if="display_mode === 'delivery_dp'"
    ></delivery-methods-edit-dp>

    <delivery-methods-edit-ib
      show-continue
      @close="save"
      :selected-method="
        $store.state.checkout.order_data.delivery.ib.deliveryMethod
      "
      v-else-if="display_mode === 'delivery_ib'"
    ></delivery-methods-edit-ib>

    <billing-address-edit
      @close="save"
      v-else-if="display_mode === 'billing'"
    ></billing-address-edit>

    <div class="checkout-summary" v-else>
      <div class="billing-section">
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <h2>
              Billing Address
              <small
                ><b-link @click="display_mode = 'billing'">Edit</b-link></small
              >
            </h2>
            <address-display
              class="inset-section mb-1"
              :address="billing.address"
            ></address-display>
            <b-button
              size="sm"
              variant="outline-primary"
              @click="display_mode = 'billing'"
              >Change billing address</b-button
            >
            <p class="text-muted small mt-1">
              <svg
                class="bi"
                style="margin-right: 0.2em; vertical-align: text-middle"
                width="1em"
                height="1em"
                fill="currentColor"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#exclamation-circle"
                />
              </svg>

              If you are paying by card, please ensure the address matches the
              registered address for your card, including the country. If the
              address is incorrect, your payment will fail.
            </p>
          </div>
          <div class="col-12 col-md-6 mb-2">
            <h2>Payment</h2>
            <b-alert variant="info" :show="!orderReady">
              {{ orderNotReadyReason }}
            </b-alert>
            <div class="inset-section mb-2">
              <b-form-group
                id="amount-to-pay-fieldset"
                description=""
                label="Amount to pay"
                label-for="amount-to-pay-input"
                :state="validateState('amount_to_pay')"
              >
                <b-input-group prepend="£">
                  <b-form-input
                    id="amount-to-pay-input"
                    v-model="$v.amount_to_pay.$model"
                    :state="validateState('amount_to_pay')"
                    trim
                  ></b-form-input>
                </b-input-group>

                <b-form-invalid-feedback id="amount-to-pay-live-feedback"
                  >Please enter a valid number.</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <div class="place-order-section text-center">
              <b-form-checkbox
                id="checkbox-tcs"
                v-model="tcs_accepted"
                name="checkbox-tcs"
                class="mb-2"
                value="accepted"
                unchecked-value="not_accepted"
              >
                I have read and accept the
                <a href="/standard-terms-and-conditions" target="_blank"
                  >terms and conditions</a
                >
                of sale
              </b-form-checkbox>

              <b-button
                size="lg"
                class="mb-5"
                :disabled="!orderReady"
                variant="success"
                @click="placeOrder"
                >Make Payment</b-button
              >
            </div>
          </div>
          <div class="col-12 order-2 order-md-3"></div>
        </div>
      </div>
    </div>

    <b-modal
      title="Please Wait"
      no-close-on-esc
      no-close-on-backdrop
      ok-disabled
      cancel-disabled
      hide-footer
      hide-header-close
      centered
      id="modal-place-order"
    >
      <p class="text-center">{{ place_order_message }}</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddressDisplay from "@/components/AddressDisplay.vue";
import BillingAddressEdit from "@/components/checkout/BillingAddressEdit";
import { required, decimal } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      amount_to_pay: 100,
      display_mode: "summary",
      place_order_message: "",
      tcs_accepted: "not_accepted",
    };
  },
  components: {
    AddressDisplay,
    BillingAddressEdit,
  },
  validations: {
    amount_to_pay: {
      required,
      decimal,
    },
  },
  computed: {
    ...mapGetters("readiness", ["is_ready"]),
    billing() {
      return this.$store.state.checkout.order_data.billing;
    },
    orderNotReadyReason() {
      if (this.tcs_accepted !== "accepted") {
        return "You must agree to our Terms and Conditions to make a payment.";
      }

      return "";
    },
    orderReady() {
      if (this.tcs_accepted !== "accepted") {
        return false;
      }

      return true;
    },
  },
  watch: {
    display_mode() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.display_mode = "summary";
    },
    placeOrder() {
      this.place_order_message = "Redirecting you to the payment gateway...";
      this.$bvModal.show("modal-place-order");

      this.$store
        .dispatch("checkout/make_bill_payment")
        .then(() => {})
        .catch((error) => {
          this.$bvModal.hide("modal-place-order");
          this.showError(
            "There was a problem making your bill payment.",
            "Sorry, we are experiencing technical difficulties, please try again later.",
            error
          );
        });
    },
  },
  mounted() {},
};
</script>